import type { TGetColaboradoresByUnidadeDeNegocioParams } from '@/features/configuracoes/interfaces/configuracoes.types'

export const empresaKeys = {
  empresas: ['empresas'] as const,
  lista: () => [...empresaKeys.empresas, 'lista'] as const,
}

export const colaboradorKeys = {
  colaboradores: ['colaboradores'] as const,
  lista: (unidadeDeNegocioId: string, query: Partial<TGetColaboradoresByUnidadeDeNegocioParams>) =>
    [...colaboradorKeys.colaboradores, 'lista', unidadeDeNegocioId, query] as const,
  atualizar: () => [...colaboradorKeys.colaboradores, 'atualizar'] as const,
}

export const reservaKeys = {
  reserva: ['reserva'] as const,
  atualizarConfiguracaoReservaEmpreendimento: () =>
    [...reservaKeys.reserva, 'atualizar-configuracao-reserva-empreendimento'] as const,
  atualizarConfiguracaoReservaUnidadeNegocio: () =>
    [...reservaKeys.reserva, 'atualizar-configuracao-reserva-unidade-negocio'] as const,
}

export const termosKeys = {
  termos: ['termos'] as const,
  buscar: (unidadeDeNegocioId: string) => [...termosKeys.termos, 'buscar', unidadeDeNegocioId] as const,
  atualizar: () => [...termosKeys.termos, 'atualizar'] as const,
}

export const parametrosKeys = {
  parametros: ['parametros'] as const,
  buscarPeriodoValidade: (unidadeDeNegocioId: string) =>
    [...parametrosKeys.parametros, 'buscar-periodo-validade', unidadeDeNegocioId] as const,
  atualizarPeriodoValidade: () => [...parametrosKeys.parametros, 'atualizar-periodo-validade'] as const,
}

export const coresKeys = {
  cores: ['cores'] as const,
  buscar: (empreendimentoId: number) => [...coresKeys.cores, 'buscar', empreendimentoId] as const,
  atualizarCoresLotes: () => [...coresKeys.cores, 'atualizar-cores-lotes'] as const,
}

export const empreendimentosKeys = {
  empreendimentos: ['empreendimentos'] as const,
  horizontais: () => [...empreendimentosKeys.empreendimentos, 'horizontais'] as const,
}
